<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoListar">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoListar">
            <div class="formgroup" *ngIf="permissaoInserir">
                <div class="p-fluid p-formgrid grid">
                    <div class="field col-12 md:col-2">
                        <button
                            pButton
                            pRipple
                            routerLink="/apps/outras-receitas/inserir"
                            label="Novo"
                            icon="pi pi-plus"
                            class="p-button-outlined sm:w-9rem"
                        ></button>
                    </div>
                </div>
            </div>
            <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                <p-messages
                    [(value)]="messages"
                    [enableService]="false"
                    [closable]="true"
                ></p-messages>
            </div>
            <p-table
                #dt1
                [value]="listaOutrasReceitas"
                dataKey="id"
                [rows]="10"
                [loading]="loading"
                [rowHover]="true"
                [paginator]="true"
                [globalFilterFields]="[
                    'planoContaEmpresa.descricao',
                    'identificacao',
                    'tipoPagamento.descricao',
                ]"
                responsiveLayout="stack"
                styleClass=" p-datatable-sm"
            >
                <ng-template pTemplate="caption">
                    <div class="flex justify-content-between flex-column sm:flex-row">
                        <div class="p-fluid w-full sm:w-auto mr-2">
                            <label htmlFor="filtroCompetencia">Competência</label>
                            <p-dropdown
                                [options]="listaCompetenciasReceitas"
                                emptyFilterMessage="Nenhum registro"
                                name="filtroCompetencia"
                                ngModel
                                #filtroCompetencia="ngModel"
                                emptyMessage="Nenhum registro"
                                [(ngModel)]="filtroCompetenciaSelecionada"
                                (onChange)="recarregarDados()"
                            ></p-dropdown>
                        </div>
                        <div class="p-fluid w-full sm:w-auto mt-2 sm:mt-4">
                            <div class="flex">
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input
                                        pInputText
                                        type="text"
                                        #filter
                                        (input)="buscar(dt1, $event)"
                                        placeholder="Buscar"
                                        class="w-full"
                                    />
                                </span>
                                <span class="ml-2">
                                    <button
                                        pButton
                                        class="p-button-outlined"
                                        icon="pi pi-filter-slash"
                                        pTooltip="Limpar Filtros"
                                        (click)="limpar(dt1)"
                                    ></button>
                                </span>
                            </div>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="planoContaEmpresa.descricao">
                            Especificação
                            <p-sortIcon field="planoContaEmpresa.descricao"></p-sortIcon>
                        </th>
                        <th pSortableColumn="identificacao">
                            Identificação
                            <p-sortIcon field="identificacao"></p-sortIcon>
                        </th>
                        <th pSortableColumn="dataFluxo">
                            Data da Receita
                            <p-sortIcon field="dataFluxo"></p-sortIcon>
                        </th>
                        <th pSortableColumn="valorFluxo">
                            Valor da Receita
                            <p-sortIcon field="valorFluxo"></p-sortIcon>
                        </th>
                        <th pSortableColumn="tipoPagamento">
                            Tipo de Receita
                            <p-sortIcon field="tipoPagamento"></p-sortIcon>
                        </th>

                        <th>
                            <div>Ações</div>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>
                            {{ item.planoContaEmpresa.descricao }}
                        </td>
                        <td>
                            {{ item.identificacao }}
                        </td>
                        <td>
                            {{ item.dataFluxo | date: "dd/MM/yyyy" }}
                        </td>
                        <td>
                            {{ item.valorFluxo | currency: "BRL" : "symbol" : "1.2-2" }}
                        </td>
                        <td>
                            {{ item.tipoPagamento?.descricao }}
                        </td>

                        <td style="text-align: center">
                            <div>
                                <button
                                    pButton
                                    pRipple
                                    pTooltip="Editar"
                                    (click)="editarOutraReceita(item.id)"
                                    icon="pi pi-pencil"
                                    class="p-button-success mr-2 mb-2"
                                    *ngIf="permissaoEditar"
                                ></button>
                                <button
                                    pButton
                                    pRipple
                                    pTooltip="Detalhar"
                                    (click)="excluirOutraReceita(item.id)"
                                    icon="pi pi-trash"
                                    pTooltip="Excluir"
                                    class="p-button-danger mr-2 mb-2 sm"
                                    *ngIf="permissaoExcluir"
                                ></button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7">Nenhum registro encontrado.</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="loadingbody">
                    <tr>
                        <td colspan="7">Carregando Tipos de Pagamentos. Por favor aguarde.</td>
                    </tr>
                </ng-template>
            </p-table>
            <p-confirmDialog [style]="{ width: '50vw' }"></p-confirmDialog>
        </div>
    </div>
</div>
